import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import StickyHeader from '../../../../views/app/StickyHeader';
import { DetailsBackground } from '../../../../views/ats-details/details-background/details-background';
import { FallbackProps } from '../../../error-boundary';
import { MotionModal } from '../../../motion-modal/motion-modal';
import css from './player-error-fallback.module.scss';

interface PlayerErrorFallbackProps extends FallbackProps {
  image?: string;
}

export function PlayerErrorFallback({ error, reset, image }: PlayerErrorFallbackProps) {
  return (
    <Fragment>
      <StickyHeader />
      <DefaultErrorModal error={error} reset={reset} />
      {image !== undefined && <DetailsBackground src={image} />}
    </Fragment>
  );
}

function DefaultErrorModal({ error, reset }: PlayerErrorFallbackProps) {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <MotionModal classNames={{ content: css.content }} onRequestClose={() => history.goBack()} offsetTop={164} isOpen>
      <h2 className={css.title}>{t('an_error_occured')}</h2>
      <p className={css.message}>{error.message}</p>
      <MotionModal.Button className={css.button} onClick={() => history.goBack()}>
        {t('close')}
      </MotionModal.Button>
    </MotionModal>
  );
}
